import { colors, font, text, radius } from '../design/tokens'

/**
 * Nota que el comprador escribió en el checkout (Magento / tienda web).
 *
 * Es una instrucción del CLIENTE ("entregar después de las 14", "es un regalo,
 * sin precios"), no una anotación interna — por eso no vive enterrada en las
 * observaciones sino en un banner que no se puede pasar por alto. Se muestra
 * en el detalle de la NV, en el form de edición y en la versión móvil.
 */
export default function NotaClienteBanner({ nota, compacto = false }) {
  if (!nota) return null

  return (
    <div style={{
      background: colors.warnBg,
      border: '1px solid #fcd34d',
      borderLeft: '4px solid #f59e0b',
      borderRadius: radius.md,
      padding: compacto ? '0.6rem 0.85rem' : '0.8rem 1.1rem',
      marginBottom: '1rem',
    }}>
      <div style={{
        fontSize: text.meta,
        fontWeight: 700,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: colors.warn,
        marginBottom: 4,
      }}>
        💬 Nota del cliente — leer antes de preparar el pedido
      </div>
      <div style={{
        fontFamily: font.sans,
        fontSize: compacto ? text.body : '0.95rem',
        color: colors.text,
        whiteSpace: 'pre-wrap',
        lineHeight: 1.45,
      }}>
        {nota}
      </div>
    </div>
  )
}
